import { es } from './es/dictionary';

export const dict = {
    'es': es
}
